import { render, staticRenderFns } from "./RaceForm1.vue?vue&type=template&id=193146e3&scoped=true&"
import script from "./RaceForm1.vue?vue&type=script&lang=js&"
export * from "./RaceForm1.vue?vue&type=script&lang=js&"
import style0 from "./RaceForm1.vue?vue&type=style&index=0&id=193146e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193146e3",
  null
  
)

export default component.exports